import WorldSystem from '../WorldSystem';
import ITask from '../../../Utility/Task/ITask';
import {
    GetAnimationClip,
    PlayAnimation,
    StartAnimation,
    StopAnimation,
} from '../../Animation/AnimationHelper';
import Game from '../../../Game';

export default class LevelNodeCompleteTask implements ITask<WorldSystem> {
    public *execute(system: WorldSystem): IterableIterator<number> {
        const currentNode = system.getCurrentLevelNode();
        const currentLevel = system.getCurrentLevelNumber();
        const previousNode = system.levelNodes.get(currentLevel - 1);

        if (
            currentNode &&
            previousNode &&
            currentNode !== previousNode &&
            Game.player.getHighestLevelNumber() === currentLevel
        ) {
            const playerIcon = system.playerIcon.find('iconContainer');
            StopAnimation(playerIcon);

            const clip = GetAnimationClip(
                'PlayerIconLevelComplete',
                system.playerIcon,
                {
                    currentNode: currentNode,
                    previousNode: previousNode,
                }
            );
            yield* PlayAnimation(clip);

            StartAnimation(playerIcon, 'PlayerIconIdle');
        }
    }
}
